module.exports = __webpack_public_path__ + "static/img/4.d2b39e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcgzgk/4.png
// module id = GG+3
// module chunks = 0